import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as css from './reg-item-form.scss'
import ImageUploadPreviewer from 'shared/image-upload-previewer/image-upload-previewer'
import { Input } from 'components/forms'
import CategorySelector from './category-selector'

export default class ExternalRegistryFields extends Component {
  static propTypes = {
    categories: PropTypes.array,
    regItem: PropTypes.object,
    onRegItemChange: PropTypes.func.isRequired,
    onNewCategoryChange: PropTypes.func.isRequired,
  }

  onImageChange = ({ imgUrl }) => {
    this.props.onRegItemChange({ imgUrl })
  }
  handleChange = (e) => {
    this.props.onRegItemChange({ [e.target.name]: e.target.value })
  }

  render() {
    const regItemFields = this.props.regItem

    return (
      <React.Fragment>
        <div className={css.item}>
          <div className={css.imageContainer}>
            <ImageUploadPreviewer
              imgUrl={regItemFields.imgUrl}
              onChange={this.onImageChange}
            />
          </div>

          <div className={css.itemFields}>
            <Input
              label="Title"
              value={regItemFields.title}
              onChange={this.handleChange}
              name="title"
              error={regItemFields.title ? null : 'Title cannot be blank'}
            />

            <CategorySelector
              name="categoryId"
              value={regItemFields.categoryId}
              categories={this.props.categories}
              onCategoryChange={this.props.onRegItemChange}
              onCategoryAdd={this.props.onNewCategoryChange}
            />
          </div>
        </div>

        <Input
          label="Url"
          value={regItemFields.url}
          onChange={this.handleChange}
          name="url"
          groupClassName="mbl"
          error={regItemFields.url ? null : 'Url cannot be blank'}
        />

        <Input
          label="Notes"
          type="textarea"
          onChange={this.handleChange}
          name="description"
          value={regItemFields.description || ''}
          className={css.notes}
          placeholder="Tell Gift Givers what they should know about this registry."
        />
      </React.Fragment>
    )
  }
}
